module.exports = __webpack_public_path__ + "img/hr-tree-03-a-trunk.91d5c735.png";